import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const EDIT_DATETIME = 'EDIT_DATETIME'

const general = {
    namespaced: true,
    state: {
        datetime: ''
    },
    mutations: {
        EDIT_DATETIME (state, data) {
            state.datetime = data
        }
    },
    getters: {
        datetime (state) {
            return state.datetime
        }
    },
    actions: {
        async setDate ({ dispatch, commit, getters, rootGetters }, data) {
            try {
                commit(EDIT_DATETIME, data)
            } catch (error) {
                throw new Error('ERROR_SETTING_DATETIME')
            }
        }
    }
}

export default general
